export const getReloadedFeeCollections = (registration) => ({
  additionalFees: Array.isArray(registration?.additionalFees)
    ? registration.additionalFees
    : [],
  zeroPayments: Array.isArray(registration?.zeroPayments)
    ? registration.zeroPayments
    : [],
});

export const mergeAccompanyingPersonsWithReloadedFees = ({
  accompanyingPersons,
  accompanyingPersonFee,
  reloadedRegistration,
}) => {
  if (!accompanyingPersonFee) {
    return accompanyingPersons;
  }

  const { additionalFees, zeroPayments } =
    getReloadedFeeCollections(reloadedRegistration);

  console.log("🔍 Current accompanyingPersons state (before mapping):", accompanyingPersons);
  console.log("   Current state count:", accompanyingPersons.length);

  const updatedAccompanyingPersons = accompanyingPersons.map((person) => {
    const matchingFee = additionalFees.find(
      (fee) =>
        fee.feeTypeId === accompanyingPersonFee.id && fee.name === person.name
    );

    const matchingZeroPayment = zeroPayments.find(
      (zeroPayment) =>
        zeroPayment.feeTypeId === accompanyingPersonFee.id &&
        zeroPayment.name === person.name
    );

    if (matchingFee) {
      console.log(
        `  ✓ Found match in additionalFees for "${person.name}":`,
        matchingFee
      );
      return {
        ...person,
        paymentId: matchingFee.paymentId || null,
        paid: !!matchingFee.paymentId,
        feeTypeId: matchingFee.feeTypeId,
        id: matchingFee.id,
      };
    }

    if (matchingZeroPayment) {
      console.log(
        `  ✓ Found match in zeroPayments for "${person.name}":`,
        matchingZeroPayment
      );
      return {
        ...person,
        paymentId: null,
        paid: true,
        feeTypeId: matchingZeroPayment.feeTypeId,
        id: matchingZeroPayment.id,
      };
    }

    console.log(`  ⚠️ No match found for "${person.name}" - keeping as is (new item)`);
    return person;
  });

  console.log(
    "✅ Updated accompanyingPersons state after save (with DB IDs):",
    updatedAccompanyingPersons
  );
  console.log("   Updated state count:", updatedAccompanyingPersons.length);
  console.log("   If count decreased, deletions were preserved ✓");
  console.log("   If count stayed same/increased, items may have been restored from DB ✗");

  return updatedAccompanyingPersons;
};
